<script lang="ts" setup>
  import { computed } from "vue";
  import BaseModal from "@/components/modals/BaseModal.vue";
  import SimpleBG from "@/components/backgrounds/SimpleBG.vue";

  const props = withDefaults(defineProps<{
    modelValue: boolean;
    compact?: boolean;
    minimal?: boolean;
  }>(), {
    modelValue: false,
    compact: false,
    minimal: false,
  });

  const emit = defineEmits<{
    'update:modelValue': [value: boolean];
    'close': [],
  }>();

  const value = computed<boolean>({
    get() {
      return props.modelValue;
    },
    set(value) {
      emit('update:modelValue', value);
    },
  });
</script>

<template>
  <BaseModal
    v-model="value"
    @close="$emit('close')"
    :dark="false"
    scrollable
  >
    <SimpleBG :compact="compact" :minimal="minimal">
      <slot></slot>
    </SimpleBG>
  </BaseModal>
</template>

<style lang="scss" scoped>
</style>
